/**
 * Konstanty ploch lidí na webu (vize podnety-tymu-2026-10, řez 06): medailonek karty
 * specialisty, galerie profilu průvodce a výčet zemí na kartě `/pruvodci`.
 *
 * Řádky `export const <JMÉNO> = <číslo>;` drž doslova v tomto tvaru (precedent
 * `media/batches.ts`): měřidla a E2E je čtou z textu souboru, protože ze `scripts/`
 * nejde importovat `@ckgo2/shared`.
 */
import type { GuideTips } from "./types";

/**
 * Od kolika znaků bio karty specialisty se medailonek zkrátí na čtyři řádky s ovladačem
 * „Číst dál“ (4 řádky karty 360 px, ~55 znaků na řádek). Kratší bio se ukáže celé.
 */
export const MEDAILONEK_PRAH_ZNAKU = 220;
/** Nejvýš fotek v galerii profilu průvodce (API ořízne, web víc nečeká). */
export const GUIDE_GALLERY_MAX = 24;
/** Nejvýš zemí vypsaných na kartě `/pruvodci`; zbytek je „+N“ (`data-zeme-navic`). */
export const GUIDE_CARD_MAX_COUNTRIES = 3;

/**
 * Klíče tipů průvodce (`GuideTips`, vize F6.4) v pořadí editoru i profilu: oblíbené místo nebo
 * zážitek, co ochutnat, rada před cestou. JEDINÝ výčet: admin podle něj kreslí pole, API podle
 * něj vydává tipy (jiný klíč řádku neodejde) a web podle něj řadí a popisuje úsek tipů.
 * `allGuideTipKeys` drží úplnost: klíč `GuideTips`, který tu chybí, shodí typecheck, takže
 * nový tip nemůže v jedné vrstvě tiše vypadnout.
 */
export const GUIDE_TIP_KEYS = allGuideTipKeys(["favoritePlace", "food", "advice"] as const);

export type GuideTipKey = (typeof GUIDE_TIP_KEYS)[number];

function allGuideTipKeys<const K extends readonly (keyof GuideTips)[]>(
  keys: K & ([Exclude<keyof GuideTips, K[number]>] extends [never] ? unknown : never),
): K {
  return keys;
}
